import { create } from "zustand";

type PanelView =
  | "chat"
  | "history"
  | "designLibrary"
  | "pageSettings"
  | "manageChats";

interface EditorStore {
  panelView: PanelView;

  actions: {
    setPanelView: (panelView: PanelView) => void;
  };
}

const useEditorStore = create<EditorStore>((set) => ({
  panelView: "chat",

  actions: {
    setPanelView: (panelView: PanelView) => set({ panelView }),
  },
}));

export const usePanelView = () => useEditorStore((state) => state.panelView);

// NOTE (Bobby: 2025-07-09): Creating just one selector for all actions since actions are static and never change
// so regardless they don't cause any re-renders or impact performance.
export const useEditorStoreActions = () =>
  useEditorStore((state) => state.actions);
